import styled from 'styled-components';
import { Buttons, FlexContainer } from '@taxdown/piccolo-web';
import { Lottie as Lottie_ } from 'Components/UI';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)<{ $inView: boolean }>`
  background-color: ${({ theme: { system } }) =>
    system.background.fds_sys_color_background_success};
  h2 {
    line-height: 100%;
  }
  h3 {
    line-height: 110%;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    height: 100%;
    flex-direction: column;
    text-align: center;
    margin: ${({ $inView }) => ($inView ? '-20px' : '0')};
    h2 {
      font-size: 24px;
    }
    h3 {
      font-size: 20px;
    }
    button {
      margin: 0 auto;
    }
  }
`;

export const Lottie = styled(Lottie_)`
  width: 100%;
  max-width: 347px;
  margin-right: 90px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    max-width: 150px;
    margin-right: 0;
  }
`;

export const Link = styled(Buttons.Tiny)`
  display: inline-block;
  vertical-align: middle;
`;

export const ExternalLink = styled.a`
  text-decoration: underline;
`;

export const Content = styled(FlexContainer)`
  max-width: 378px;
`;
